import { jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import clsx from "clsx";
import { useThemeProps, extendSxProp } from "@tino-frontend/coreui";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { useUtilityClasses } from "./markdown.classes.js";
import { MarkdownRoot } from "./markdown.styles.js";
import { MarkdownHR, MarkdownLink, MarkdownList, MarkdownParagraph, MarkdownHeading } from "./elements.component.js";
const Markdown = forwardRef(function Markdown2(inProps, ref) {
  const themeProps = useThemeProps({ props: inProps, name: "TrueMarkdown" });
  const props = extendSxProp({ ...themeProps });
  const {
    heading = {},
    h1 = {},
    h2 = {},
    h3 = {},
    h4 = {},
    h5 = {},
    h6 = {},
    paragraph = {},
    li = {},
    a = {},
    className,
    eventId,
    render,
    disallowedElements,
    limitHeading,
    reduceHeading,
    allLinkAsTargetBlank,
    children,
    marginSpacing,
    renderHTML,
    "data-testid": dataTestid,
    ...isProps
  } = props;
  const ownerState = {
    ...isProps
  };
  const classes = useUtilityClasses(ownerState);
  const childrenParsed = useMemo(
    () => `${children}`.replace(/\n$/gm, "\n&nbsp;\n"),
    [children]
  );
  const renderers = useMemo(() => {
    const defaultProps = {
      limitHeading,
      reduceHeading,
      marginSpacing
    };
    return {
      h1: (props2) => /* @__PURE__ */ jsx(MarkdownHeading, { ...props2, ...defaultProps, ...heading, ...h1 }),
      h2: (props2) => /* @__PURE__ */ jsx(MarkdownHeading, { ...props2, ...defaultProps, ...heading, ...h2 }),
      h3: (props2) => /* @__PURE__ */ jsx(MarkdownHeading, { ...props2, ...defaultProps, ...heading, ...h3 }),
      h4: (props2) => /* @__PURE__ */ jsx(MarkdownHeading, { ...props2, ...defaultProps, ...heading, ...h4 }),
      h5: (props2) => /* @__PURE__ */ jsx(MarkdownHeading, { ...props2, ...defaultProps, ...heading, ...h5 }),
      h6: (props2) => /* @__PURE__ */ jsx(MarkdownHeading, { ...props2, ...defaultProps, ...heading, ...h6 }),
      p: (props2) => {
        const { variant = "body1", ...isProps2 } = props2;
        return /* @__PURE__ */ jsx(
          MarkdownParagraph,
          {
            ...isProps2,
            variant,
            marginSpacing,
            ...paragraph
          }
        );
      },
      span: (props2) => {
        const { variant = "inherit", ...isProps2 } = props2;
        return /* @__PURE__ */ jsx(
          MarkdownParagraph,
          {
            ...isProps2,
            variant,
            marginSpacing,
            ...paragraph,
            component: "span"
          }
        );
      },
      li: (props2) => /* @__PURE__ */ jsx(MarkdownList, { ...li, ...props2 }),
      a: (props2) => /* @__PURE__ */ jsx(
        MarkdownLink,
        {
          ...props2,
          allLinkAsTargetBlank,
          ...a
        }
      ),
      hr: () => /* @__PURE__ */ jsx(MarkdownHR, {}),
      ...render && render(props)
    };
  }, [props]);
  return /* @__PURE__ */ jsx(
    MarkdownRoot,
    {
      ...props,
      ref,
      className: clsx(classes, className),
      "data-eventid": eventId,
      "data-testid": dataTestid,
      components: renderers,
      remarkPlugins: [remarkGfm],
      disallowedElements,
      rehypePlugins: renderHTML ? [rehypeRaw] : [],
      children: childrenParsed
    }
  );
});
export {
  Markdown as default
};
//# sourceMappingURL=markdown.component.js.map
